/**
 * Lanjut hari pelanggan Flow Ultra (admin). Kerja sebenar di server —
 * `functions/flowExtendDays.js` (flow_subs tidak boleh ditulis client).
 *
 * @param {{ kind: 'sub'|'tenant', id: string }[]} items
 * @param {number} days
 * @param {string} reason
 * @returns {Promise<{ results: {kind,id,ok,from?,to?,error?}[], ok: number, failed: number }>}
 */
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function lanjutHariFlow(items, days, reason, bayaran = null) {
    const fn = httpsCallable(functions, 'adminExtendFlowDays');
    /* "Paid renewal" (2026-10-14): resit manual direkod server serentak dengan tambah hari.
       Medan disenaraikan SATU PERSATU (bukan spread) — medan yang tidak disebut tidak sampai. */
    const res = await fn({
        items, days, reason,
        ...(bayaran ? { paidSen: bayaran.paidSen, paidAt: bayaran.paidAt } : {}),
    });
    return res.data;
}

/**
 * Tetapkan tarikh tamat TERUS (mod "Set date") — fungsi server yang sama, satu log.
 * @param {string} isoTarikh 'YYYY-MM-DD' (hari Malaysia; server bundar ke 23:59 MY)
 */
export async function setTarikhFlow(items, isoTarikh, reason) {
    // Tengah hari MY → hari yang sama walau apa zon waktu browser admin.
    const setDate = new Date(`${isoTarikh}T12:00:00+08:00`).getTime();
    if (!Number.isSafeInteger(setDate)) throw new Error('Invalid date.');
    const fn = httpsCallable(functions, 'adminExtendFlowDays');
    const res = await fn({ items, setDate, reason });
    return res.data;
}
